<mat-toolbar color="accent">
  Arrival Checklist - {{ patient.name }}
</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-col gap-2">
    <h3 class="!m-0 !font-bold text-black">Forms</h3>

    <pr-patient-submitted-forms-list
      [patient]="patient"
      [loadingState]="false"
      [hideConfirmedForms]="true"
      (formSelected)="patientCustomForms.openFormDialog($event)"
    />

    <h3 class="!m-0 !font-bold text-black">Checklist</h3>

    <mat-list class="!p-0">
      <mat-list-item
        *ngFor="let item of checklist$ | async; trackBy: trackByItem"
        class="mat-list-option"
        (click)="updateSelected(item)"
      >
        <div class="basis-4/5">
          <mat-checkbox color="primary" [checked]="item.done">
            <div class="title flex basis-2/3 flex-col">
              <span class="title">{{ item.title }}</span>
            </div>
          </mat-checkbox>
        </div>
        <ng-container *ptFeatureEnabled="'appointments.checklists.actions'">
          <div
            *ngIf="item.action !== 'none'"
            class="flex items-center justify-end"
          >
            <button mat-icon-button (click)="doAction($event, item)">
              <mat-icon>{{ item.action }}</mat-icon>
            </button>
          </div>
        </ng-container>
      </mat-list-item>
    </mat-list>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-stroked-button
      [disabled]="isArrived$ | async"
      (click)="markArrival()"
    >
      Notify {{ practitioner.name }}
    </button>
    <button
      mat-stroked-button
      [disabled]="(allComplete$ | async) === false"
      (click)="checkIn()"
    >
      Complete Check In
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
